import React, { useEffect } from "react";
import icons from "../../../assets/images/sprite-other-icons.svg";
import logo from "../../../assets/images/logo-header.svg";
import { Link } from "react-router-dom";
import { setActiveItem } from "../../signIn/cl_SignInSlice";
import { useDispatch, useSelector } from "react-redux";
import { setFooterContent, setLinksContent } from "./cl_footerSlice";
import { endpoints } from "../../../api/ApiEndPoints";
import footer from '../../../assets/images/footer/18-plus.svg'

const Footer = () => {
  const dispatch = useDispatch();
  const brandid = endpoints?.fasFasBrandId || 307;
  const { staticContent, linksContent } = useSelector((state) => state?.footer);

  useEffect(() => {
    if (brandid) {
      dispatch(setFooterContent(brandid));
      dispatch(setLinksContent(brandid));
    }
  }, [dispatch, brandid]);

  return (
    <div className="SB-footer">
      <div className="SB-container">
        <div className="SB-footer-container">
          <div className="SB-footer-content">
            <div className="SB-footer-linksList SB-footer-logoInfo">
              <div className="SB-footer-logo">
                <Link to={"/"}>
                  <img src={logo} alt="FasFas Logo" loading="lazy"/>
                </Link>
                <div className="SB-footer-discription">
                  {(staticContent?.length && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: staticContent?.find(
                          (i) => i.is_active && i?.keyname === "Footer"
                        )?.is_content,
                      }}
                    />
                  )) || (
                    <p>
                      This page is powered by XXXX Gaming XX, company
                      incorporated in Africa, and licensed by the Games
                      Inspection of Africa, observing the rules applicable and
                      established in Law no. XXXX, of February 8, under the
                      Regulation of Social Games and Fun, approved by Decree No.
                      XXXX
                    </p>
                  )}
                </div>
              </div>

              <div
                className="SB-footer-linksList SB-footer-securityInfo"
                onClick={() => dispatch(setActiveItem())}
              >
                <ul>
                  {linksContent &&
                    linksContent.map((link) => (
                      <li key={link.id}>
                        {link.link_type === "Internal" ? (
                          <Link
                            to={link.menu_link}
                            onClick={(e) => {
                              e.preventDefault();
                              window.location.href = link.menu_link;
                            }}
                          >
                            {link.link_name}
                          </Link>
                        ) : (
                          <a
                            href={link.menu_link}
                            target={
                              link.is_newwindow === "Yes" ? "_blank" : "_self"
                            }
                            rel="noopener noreferrer"
                          >
                            {link.link_name}
                          </a>
                        )}
                      </li>
                    ))}
                </ul>
              </div>
              {/* {
                ( staticContent?.length && (
                  <div dangerouslySetInnerHTML={{ __html: staticContent?.find((i) => i.is_active && i?.keyname === 'SocialImages')?.is_content }} />
               ))
               || */}
              <ul className="SB-social-links">
                <li>
                  <a
                    href={
                      " https://www.facebook.com/profile.php?id=61559892426530"
                    }
                    className="SB-social-linkItem"
                  >
                    <div className="SB-iconSVG " title="Facebook">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="#FFF"
                      >
                        <use xlinkHref={`${icons}#${"icon-facebook"}`} />
                      </svg>
                    </div>
                  </a>
                </li>
                <li>
                  <a
                    href={
                      "https://api.whatsapp.com/send/?phone=254705065203&text&type=phone_number&app_absent=0&wame_ctl=1"
                    }
                    className="SB-social-linkItem"
                  >
                    <div className="SB-iconSVG " title="whatsapp">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="#FFF"
                      >
                        <use xlinkHref={`${icons}#${"icon-whatsapp"}`} />
                      </svg>
                    </div>
                  </a>
                </li>
                {/* <li>
                  <a href={''} className='SB-social-linkItem'>
                    <div className='SB-iconSVG ' title='Tiktok'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 24 24'
                        fill='#FFF'
                      >
                        <use xlinkHref={`${icons}#${'icon-tiktok'}`} />
                      </svg>
                    </div>
                  </a>
                </li> */}
                <li>
                  <a
                    href={"https://x.com/FasFasGame254"}
                    className="SB-social-linkItem"
                  >
                    <div className="SB-iconSVG " title="Twitter">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="#FFF"
                      >
                        <use xlinkHref={`${icons}#${"icon-twitter"}`} />
                      </svg>
                    </div>
                  </a>
                </li>
                <li>
                  <a
                    href={
                      "https://www.youtube.com/channel/UCyE2a57Lebj47xWBB1xN22Q"
                    }
                    className="SB-social-linkItem"
                  >
                    <div className="SB-iconSVG " title="youtube">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="#FFF"
                      >
                        <use xlinkHref={`${icons}#${"icon-youtube"}`} />
                      </svg>
                    </div>
                  </a>
                </li>
              </ul>

              {/* <ul className='SB-social-links'>
                Contact
              </ul> */}
              {/* <div className='SB-footer-linksList SB-footer-securityInfo'>
                <ul>
               
                  <li>
                    <Link
                      to='javascript:void(0)'
                      onClick={() =>
                        (window.location = 'mailto:support.ke@fasfasgames.co.ke')
                      }
                    >
                     Email : support.ke@fasfasgames.co.ke
                    </Link>
                  </li>
                  <li></li>
                </ul>
              </div> */}
            </div>
            <div className="SB-18plus-info">
              <img src= {footer} alt="18 Plus" loading="lazy" />
              <p>
                Players must be 18 years of age or older to register or play on
                FasFas. Gambling is addictive. Play Responsibly.
              </p>
            </div>
            <div className="SB-footer-copyrights">
              <div className="SB-container">
                Copyright © 2025 FasFas. All rights reserved.
              </div>
            </div>
            <div className="SB-chatBubble d-none">
              <div className="SB-chatBubble-container">
                <div className="SB-iconSVG" title="Chat">
                  <svg xmlns="http://www.w3.org/2000/svg">
                    <use xlinkHref={`${icons}#${"icon-chat"}`} />
                  </svg>
                </div>
                <div className="SB-loader-container d-none">
                  <div className="SB-loader"></div>
                </div>
              </div>
            </div>
            <div
              className="SB-scrolltoTop"
              id="SB-scrolltoTop"
              // onClick="scrollToTop();return false;"
            >
              <div className="SB-iconSVG " title="Arrow Up">
                <svg xmlns="http://www.w3.org/2000/svg">
                  <use xlinkHref={`${icons}#${"icon-icon-angle-arrow-up"}`} />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
